<template>
    <section class="about section" id="about">
        <h2 class="section__title">About Me</h2>
        <span class="section__subtitle">My Introduction</span>

        <div class="about__container container grid">
            <img src="@/assets/img/about.jpeg" alt="" class="about__img">

            <div class="about__data">
                <p class="about__description">Fullstack Developer & Backend Engineer with experience in software engineering, web application development, REST API design, database management, and cloud deployment. Dedicated to delivering high-quality, scalable, and secure software solutions.
                </p>

                <div class="about__info">
                    <div>
                        <span class="about__info-title">03+</span>
                        <span class="about__info-name">Years <br> experience</span>
                    </div>
                    <div>
                        <span class="about__info-title">20+</span>
                        <span class="about__info-name">Completed <br> projects</span>
                    </div>
                    <div>
                        <span class="about__info-title">05+</span>
                        <span class="about__info-name">Companies & <br> Clients</span>
                    </div>
                </div>

                <div class="about__buttons">
                    <a href="javascript:void(0)" class="button button--flex" style="padding: 0.7rem 0.7rem; pointer-events: none; opacity: 0.6; cursor: not-allowed;" aria-disabled="true">
                        Download CV<i class="uil uil-download-alt button__icon"></i>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
export default {
    name: 'About'
};
</script>
